import { useParams } from "react-router-dom";
import { cardData } from "../../constant/fake-data";
import React, { useState, useEffect } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/footer";
import { IMAGES } from "../../constant/Image";
import Banner from "../../components/TitleBanner/index";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IoEyeOutline } from "react-icons/io5";
import { CiHeart } from "react-icons/ci";
import { FaHeart } from "react-icons/fa"; // filled heart
import { AiOutlineQuestion } from "react-icons/ai";
import { FaCalendarAlt } from "react-icons/fa";
import Button from "../../components/Button/index";
import { IoMdCheckmark } from "react-icons/io";
import GallerySection from "../../components/GallerySection/GallerySection";
import AuctionSlider from "../../components/Auction_Card";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import { CiSearch } from "react-icons/ci";

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow next" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="15"
        viewBox="0 0 9 15"
        fill="none"
      >
        <path
          d="M9 7.50009L0 0L5.72727 7.50009L0 15L9 7.50009Z"
          fill="#0B0C0C"
        />
      </svg>
    </div>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow prev" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="15"
        viewBox="0 0 9 15"
        fill="none"
      >
        <path
          d="M0 7.49991L9 15L3.27273 7.49991L9 0L0 7.49991Z"
          fill="#0B0C0C"
        />
      </svg>
    </div>
  );
};

// Auction Slider Settings
const auctionSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};


// ⏳ Timer calculation function
const calculateTimeRemaining = (targetDate) => {
  const total = Date.parse(targetDate) - Date.now();
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));
  return { total, days, hours, minutes, seconds };
};

function AuctionDetail() {
  const { id } = useParams();
  const auction = cardData.find((item) => item.id === parseInt(id));

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const slider1 = React.useRef(null);
  const slider2 = React.useRef(null);

  // Lightbox states
  const [open, setOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  // Bid state
  const [bid, setBid] = useState(auction ? auction.startingBid : 0);

  // Timer state
  const [timer, setTimer] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [isExpired, setIsExpired] = useState(false);

  // 👁 Page Views
  const [views, setViews] = useState(2108);

  // ❤️ Likes
  const [likes, setLikes] = useState(465);
  const [liked, setLiked] = useState(false);

  // Timer effect
  useEffect(() => {
    if (!auction) return;
    const endDate = new Date(auction.endDate);

    if (Date.now() >= endDate.getTime()) {
      setIsExpired(true);
      return;
    }

    const interval = setInterval(() => {
      const newTime = calculateTimeRemaining(endDate);
      if (newTime.total <= 0) {
        setIsExpired(true);
        clearInterval(interval);
      } else {
        setTimer(newTime);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [auction]);

  useEffect(() => {
    setNav1(slider1.current);
    setNav2(slider2.current);

    // page load hone par view increase kare
    setViews((prev) => prev + 1);
  }, []);

  if (!auction) {
    return (
      <>
        <Header />
        <h2>Auction not found</h2>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />

      <Banner
        title={auction.title}
        bgImage={IMAGES.Auction_bg}
        breadcrumbs={["Products", auction.title]}
      />

      <div className="product-deatil-sec">
        <div className="container small-container">
          <div className="row">
            {/* left side images */}
            <div className="col-md-6">
              <div className="product-gallery-box">
                {/* Main Image Slider */}
                <Slider
                  asNavFor={nav2}
                  ref={slider1}
                  arrows={false}
                  fade={false}
                >
                  {auction.images.map((img, index) => (
                    <div
                      key={index}
                      className="main-image-wrapper"
                      style={{ position: "relative" }}
                    >
                      <img
                        src={img}
                        alt={auction.title}
                        className="img-fluid"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setPhotoIndex(index);
                          setOpen(true);
                        }}
                      />
                      <CiSearch
                        size={28}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          color: "#fff",
                          background: "rgba(0,0,0,0.5)",
                          borderRadius: "50%",
                          padding: "5px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setPhotoIndex(index);
                          setOpen(true);
                        }}
                      />
                    </div>
                  ))}
                </Slider>

                {/* Thumbnail Slider */}
                <Slider
                  asNavFor={nav1}
                  ref={slider2}
                  slidesToShow={4}
                  swipeToSlide={true}
                  focusOnSelect={true}
                  centerMode={true}
                  className="thumb-slider mt-3"
                >
                  {auction.images.map((img, index) => (
                    <div key={index} style={{ padding: "0 5px" }}>
                      <img
                        src={img}
                        alt={auction.title}
                        className="img-fluid small-thumb"
                      />
                    </div>
                  ))}
                </Slider>
                <div className="car-overview-box">
                  <div className="text">
                    <h2>Car Overview</h2>
                    <ul>
                      {auction.carOverview.map((detail, index) => {
                        const Icon = detail.icon;
                        return (
                          <li key={index}>
                            <Icon />
                            <p>{detail.text}</p>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* right side details */}
            <div className="col-md-6">
              <div className="product-details-content">
                <div className="three-align-data">
                  <p className="lot-number">{auction.lotNumber}</p>

                  {/* 👁 Page Views */}
                  <p className="page-view eye">
                    <IoEyeOutline /> {views}
                  </p>

                  {/* ❤️ Likes */}
                  <p
                    className="like-page heart"
                    onClick={() => {
                      if (!liked) {
                        setLikes((prev) => prev + 1);
                        setLiked(true);
                      } else {
                        setLikes((prev) => prev - 1);
                        setLiked(false);
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {liked ? <FaHeart style={{ color: "red" }} /> : <CiHeart />}{" "}
                    {likes}
                  </p>
                </div>

                <h2 className="product-title">{auction.title}</h2>
                <p className="product-des">{auction.productDes}</p>

                {/* Current bid with + - buttons */}
                <div className="bid-box">
                  <p className="current-bid">
                    Current bid: <br /> <span>${bid.toLocaleString()}</span>
                  </p>
                  <p className="item-condition">
                    <strong>Item Condition:</strong> {auction.itemCondition}
                  </p>
                  <div className="timer-box mt-3">
                    <p className="time-left">Time left:</p>
                    {isExpired ? (
                      <span className="live-text">Auction is Live!</span>
                    ) : (
                      <div className="d-flex gap-3">
                        <p>
                          <span>{timer.days}</span> Days
                        </p>
                        <p>
                          <span>{timer.hours}</span> Hours
                        </p>
                        <p>
                          <span>{timer.minutes}</span> Minutes
                        </p>
                        <p>
                          <span>{timer.seconds}</span> Seconds
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="auction-end-time-zone">
                    <p className="auction-ends">
                      Auction ends:{" "}
                      {new Date(auction.endDate).toLocaleString("en-US", {
                        month: "long",
                        day: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </p>
                    <p className="time-zone">Timezone: UTC 0</p>
                  </div>
                  <p className="reserve-price">Reserve price has been met</p>
                  <div className="bid-controls d-flex align-items-center">
                    <div className="plus-minus-box">
                      {/* Minus Button */}
                      <button
                        onClick={() =>
                          setBid((prev) =>
                            Math.max(prev - 100, auction.startingBid)
                          )
                        }
                        disabled={bid <= auction.startingBid} // 👈 disable logic
                        className={
                          bid <= auction.startingBid ? "disabled-btn" : ""
                        }
                      >
                        -
                      </button>

                      {/* Input Box */}
                      <input
                        type="text"
                        value={`$${bid.toLocaleString()}`}
                        readOnly
                      />

                      {/* Plus Button */}
                      <button onClick={() => setBid((prev) => prev + 100)}>
                        +
                      </button>
                    </div>
                    <button className="btn btn-danger mt-2">
                      {auction.buttonText}
                    </button>
                  </div>
                </div>

                {/* Timer below price */}

                <div className="product-sku-cat-tags">
                  <p>
                    <strong>SKU:</strong> {auction.sku}
                  </p>
                  <p>
                    <strong>Category:</strong> {auction.category}
                  </p>
                  <p>
                    <strong>Tags:</strong> {auction.tags.join(", ")}
                  </p>
                </div>
                <div className="guaranted-box">
                  <p>Guaranted Safe Checkout</p>
                  <img src={IMAGES.payment_card_img} alt="" />
                </div>
                <div className="question-watch-calendar">
                  <ul>
                    <li>
                      <a className="ask-question" href="/">
                        <div className="icon">
                          <AiOutlineQuestion />
                        </div>
                        Ask a question
                      </a>
                    </li>
                    <li>
                      <a className="watch" href="/">
                        <div className="icon">
                          <FaHeart />
                        </div>
                        Watch
                      </a>
                    </li>
                    <li>
                      <a className="add-to-calendar" href="/">
                        <div className="icon">
                          <FaCalendarAlt />
                        </div>
                        Add to Calendar
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="buyers-premium ">
        <div className="container small-container">
          <div className="row">
            <div className="col-md-12">
              <div className="box">
                <div className="buyers">
                  <div className="text">
                    <h2>Buyer’s Premium</h2>
                    <p>
                      The Buyer’s Premium is charged in addition to the sale
                      price and is payable directly to Car Auction. The fee and
                      whether you are charged sales tax is based on your
                      location.
                    </p>
                    <ul>
                      <li>Buyer’s premium is 6.0%</li>
                      <li>Minimum fee is $2,000.00</li>
                      <li>Maximum fee is $11,000.00 for buyers in CA</li>
                    </ul>
                    <p>
                      For more information, please check{" "}
                      <a href="/">our fees</a>
                    </p>
                  </div>
                </div>

                {/* Lot & Seller */}
                <div className="lot-seller">
                  {/* Lot Overview */}
                  <div className="lot-overview">
                    <div className="text">
                      <h2>Lot Overview</h2>
                      <ul>
                        {auction.lotOverview.map((item, index) => (
                          <li key={index}>
                            <img src={item.img} alt="" />
                            {item.text}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  {/* Seller */}
                  <div className="seller">
                    <div className="text">
                      <h2>Seller</h2>
                      <ul>
                        <li>
                          <img src={auction.seller.img} alt="" />
                          <a href={auction.seller.link}>
                            {auction.seller.name}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="product-details-tabs">
        <div className="container small-container">
          <div className="row">
            <div className="col-md-12">
              {/* Bootstrap Tabs */}
              <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="description-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#description"
                    type="button"
                    role="tab"
                  >
                    Description
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="auction-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#auction"
                    type="button"
                    role="tab"
                  >
                    Auction History
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="reviews-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#reviews"
                    type="button"
                    role="tab"
                  >
                    Reviews
                  </button>
                </li>
              </ul>

              <div className="tab-content" id="myTabContent">
                {/* Description Tab */}
                <div
                  className="tab-pane fade show active"
                  id="description"
                  role="tabpanel"
                  aria-labelledby="description-tab"
                >
                  <div className="content-box">
                    <div className="text">
                      <h6>They’re kinda our Best thing!</h6>
                      <p>
                        Urna Aenean onewaryzo eleifend vitae tellus a facilisis.
                        Nunc posuere at augue eget port. Inei odion goat tellus,
                        dignissim fermentumara purus nec, consequat dapibus
                        metus. Vav urna worlda mauris, goat te faucibus at
                        egestas quis, fermentum egetonav neque. Dphare lectus
                        nec risusonl pellentesque,
                      </p>
                      <p>
                        Urna Aenean onewaryzo eleifend vitae tellus a facilisis.
                        Nunc posuere at augue eget port. Inei odion goat tellus,
                        dignissim fermentumara purus nec,
                      </p>
                      <ul>
                        <li>
                          <IoMdCheckmark /> Paraben-Free
                        </li>
                        <li>
                          <IoMdCheckmark /> Sulfate-Free
                        </li>
                        <li>
                          <IoMdCheckmark /> Sephora
                        </li>
                        <li>
                          <IoMdCheckmark /> Cruelty-Free
                        </li>
                        <li>
                          <IoMdCheckmark /> Antioxidants
                        </li>
                        <li>
                          <IoMdCheckmark /> Paraben-Free
                        </li>
                      </ul>
                      <p>
                        Urna Aenean onewaryzo eleifend vitae tellus a facilisis.
                        Nunc posuere at augue eget port. Inei odion goat tellus,
                        dignissim fermentumara purus nec, consequat dapibus
                        metus. Vav urna worlda mauris, goat te faucibus at
                        egestas quis, fermentum egetonav neque. Dphare lectus
                        nec risusonl pellentesque,
                      </p>
                      <p>
                        Urna Aenean onewaryzo eleifend vitae tellus a facilisis.
                        Nunc posuere at augue eget port. Inei odion goat tellus,
                        dignissim fermentumara purus nec, consequat dapibus
                        metus. Vav urna worlda mauris, goat te faucibus at
                        egestas quis, fermentum egetonav neque. Dphare lectus
                        nec risusonl pellentesque,
                      </p>
                    </div>
                  </div>
                </div>

                {/* Auction History Tab */}
                <div
                  className="tab-pane fade"
                  id="auction"
                  role="tabpanel"
                  aria-labelledby="auction-tab"
                >
                  <div className="content-box">
                    <div className="text">
                      <h6>Auction History</h6>
                    </div>
                  </div>
                </div>

                {/* Reviews Tab */}
                <div
                  className="tab-pane fade"
                  id="reviews"
                  role="tabpanel"
                  aria-labelledby="reviews-tab"
                >
                  <div className="content-box">
                    <div className="text">
                      <h6>Customer Reviews</h6>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Bootstrap Tabs */}
            </div>
          </div>
        </div>
      </section>

      <section className="own-email-sec">
        <div className="container small-container">
          <div className="row">
            <div className="col-md-6">
              <div className="box blue-box">
                <div className="text">
                  <h4>Own a Similar {auction.title} ?</h4>
                  <p>
                    Clearly state your pricing structure, payment terms and and
                    any additional charges. Specifying when & payment invoices
                    will be issued.
                  </p>
                  <button className="btn-outline">Sell it with Us</button>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="box red-box">
                <div className="text">
                  <h4>Email Alerts</h4>
                  <p>
                    Notify me when new 1995 Porsche 928 GTS listings go live.
                    Clearly state your pricing structure, payment terms.
                  </p>
                  <button className="btn-filled">Notify Me</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="product-image-showcase">
        <div className="container small-container">
          <div className="row">
            <div className="col-md-12">
              <GallerySection
                title="Exterior"
                images={auction.galleries.exterior}
              />
              <GallerySection
                title="Interior"
                images={auction.galleries.interior}
              />
              <GallerySection
                title="Mechanical"
                images={auction.galleries.mechanical}
              />
              <GallerySection
                title="Documents"
                images={auction.galleries.documents}
              />
            </div>
          </div>
        </div>
      </section>

            <section className="upcoming-auction latest-auction ongoing-auction recently-sold related-products ">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text">
                <div className="bottom-line bottom-line-non">
                  <h2>
                    Recently <span>Sold</span>
                  </h2>
                </div>
              </div>
              <Slider {...auctionSettings}>
                {cardData.map((val) => (
                  <AuctionSlider item={val} key={val.id} />
                ))}
              </Slider>

              <div className="t-btn-center">
                <Button
                  text="View All Auctions"
                  primary={true}
                  icon={true}
                  onClick={() => console.log("View All Auctions clicked")}
                  style={{ fill: "black" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={photoIndex}
        slides={auction.images.map((img) => ({ src: img }))}
      />

      <Footer />
    </>
  );
}

export default AuctionDetail;
